import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studySubjectManagementServices } from "../../../../../APIServices/studySubjectManagementServices";
import { studyRandomizerMetadataServices } from "../../../../../APIServices/studyRandomizerMetadataServices";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const AssignRandomizationSubject = ({ siteId, subjectId, getStudySiteSubjectList, Show, Hide, Title, subjectSettings }) => {
  const [randomizerId, setRandomizerId] = useState("");
  const [randomizerList, setRandomizerList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams()
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const assignRandomizationNumber = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Assign Randomization Number!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        if (subjectSettings === "IWRS") {
          userData.randomizerId = randomizerId;
        }
        let data = await studySubjectManagementServices.assignRandomizationNumber(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
          setButtonLoader(false)
          setRandomizerId("")
          Hide()
        }
      }
    });
  };

  const getAssignedRandomizerList = async (e) => {
    let data = await studyRandomizerMetadataServices.getAssignedRandomizerList(
      studyId,
      StudyMode
    );
    setRandomizerList(data?.data || []);
  };
  
  useEffect(() => {
    getAssignedRandomizerList()
  }, []);
  
  const getStudySingleSubjectRow = async () => {
    setLoader(true)
    let data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, siteId, subjectId)
    setRandomizerId(data?.data?.randomizerId || "")
    setLoader(false)
  }

  useEffect(() => {
    if (siteId && subjectId) {
      getStudySingleSubjectRow();
    }
  }, [siteId, subjectId]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {loader ? (
            <PageLoader />
          ) : (
            <>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Randomizer
                </Form.Label>
                <Form.Select
                  style={{ fontSize: 12 }}
                  className="br3"
                  disabled={randomizerList?.length === 0}
                  onChange={(e) => setRandomizerId(e.target.value)}
                >
                  <option selected={randomizerId === ""} value="">Select Randomizer</option>
                  {randomizerList?.map((item, index) => (
                    <option key={index} selected={randomizerId === item?.randomizerId} value={item?.randomizerId}>{item?.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={buttonLoader || !randomizerId}
            onClick={assignRandomizationNumber}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Assigning...
              </div>
            ) : (
              "Assign Randomization Number"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AssignRandomizationSubject;
